import { render, staticRenderFns } from "./hotel-info-demo.vue?vue&type=template&id=023c8ec3&"
import script from "./hotel-info-demo.vue?vue&type=script&lang=ts&"
export * from "./hotel-info-demo.vue?vue&type=script&lang=ts&"
import style0 from "./hotel-info-demo.vue?vue&type=style&index=0&id=023c8ec3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports